import React from "react";
import {
  Paper,
  Box,
  Typography,
  Button,
  Chip,
  CircularProgress,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useNavigate } from "react-router-dom";
import { getMatchmakerProfile } from "../../../utilities/aiMatchmaker";

const AIMatchmakerCard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [hasProfile, setHasProfile] = React.useState(false);

  React.useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    const result = await getMatchmakerProfile();
    if (result.success) {
      setHasProfile(result.hasProfile);
    }
    setLoading(false);
  };

  return (
    <Paper
      height={3}
      sx={{
        p: 2.25,
        border: "1px solid rgba(239, 82, 65, 0.18)",
        background: "linear-gradient(180deg, #fff 0%, #fff7f5 100%)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: "50%",
            bgcolor: "rgba(239, 82, 65, 0.12)",
            color: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <AutoAwesomeIcon fontSize="small" />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontSize: 18, fontWeight: 600 }}>
            Matchmaker
          </Typography>
          {!hasProfile && !loading ? (
            <Chip
              label="NEW"
              size="small"
              color="primary"
              sx={{ height: 20, fontSize: 11, fontWeight: 700 }}
            />
          ) : null}
        </Box>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
          <CircularProgress size={22} />
        </Box>
      ) : hasProfile ? (
        <Box>
          <Typography
            sx={{
              fontSize: 13,
              color: "text.secondary",
              lineHeight: 1.45,
              mb: 2,
            }}
          >
            Your Matchmaker is set up.
          </Typography>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => navigate("/matchprofile")}
          >
            View
          </Button>
        </Box>
      ) : (
        <Box>
          <Typography
            sx={{
              fontSize: 13,
              color: "text.secondary",
              lineHeight: 1.45,
              mb: 2,
            }}
          >
            Everyone in our pool has shown up to a real event: verified
            people, real intention, no bots. Tell us about you and your ideal
            match, and we'll introduce you between events.
          </Typography>
          <Button
            variant="contained"
            fullWidth
            onClick={() => navigate("/matchprofile")}
          >
            Start
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default AIMatchmakerCard;
